<template>
  <div class="fixed inset-0 flex items-center justify-center">
    <BaseLoader class="w-10 h-10" />
  </div>
</template>

<script lang="ts">
import BaseLoader from '@/components/BaseLoader.vue';
export default {
  components: {
    BaseLoader,
  },
};
</script>
